<template>
  <div class="workflow">
    <div class="card">
      <h6>Assignment Detail</h6>
      <span v-if="PMC_itemDet.JOBNO">
        JOBNO. :{{ PMC_itemDet.JOBNO }}
        <br />
        JOB Date :{{ PMC_itemDet.JOBDate }}
        <br />
        JOB Type :{{ PMC_itemDet.JOBTYPE }}
        <br />
        Client :{{ PMC_itemDet.clientName }}
        <br />
        SLine :{{ PMC_itemDet.shippingLine }}
        <br />
        Branch :{{ PMC_itemDet.Branch }}
        <br />
        Job Created By :{{ PMC_itemDet.RaisedBy }}
        <br />
        Shipment Type :{{ PMC_itemDet.shipmentType }}
        <br />
        Transport Type :{{ PMC_itemDet.transportType }}
        <br />
        Job Status :{{ PMC_itemDet.JOBStatus }}
        <br />
        Billing Status :{{ PMC_itemDet.finalBillingCompletedStatus }}
        <br />
        Manifestation Date :{{ PMC_itemDet.manifestDate }}
        <br />
        Note Details :
        <div v-if="PMC_itemDet.NoteSeries">
        <span
          v-for="(item1, index) in PMC_itemDet.NoteSeries.split(',')"
          :key="index"
          ><h6>
            <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }} </b-badge>
          </h6></span
        >
      </div>
        <br />
        <!-- Render either truncated or full HTML string based on 'expanded' -->
        <!-- <div v-html="expanded ? PMC_itemDet.assignmentCloseReason : truncatedHTML" @click="expand"></div>
        <!-- Show ellipsis and handle click event -->
        <!-- <b-button v-if="!expanded && PMC_itemDet.assignmentCloseReason.length > maxLength" @click="expand">Close Reason</b-button> -->

        <b v-if="PMC_itemDet.assignmentCloseReason" v-html="truncateHTML(PMC_itemDet.assignmentCloseReason,50)"  style="color:green"
          >Close Reason :{{ PMC_itemDet.assignmentCloseReason }}</b
        >
        <br />
        Manifestation Status :{{ PMC_itemDet.is_maniFestSend }}
        <br />
      </span>
    </div>
    <!-- <div class="arrow"></div> -->
    <!-- <div class="delay">Delay</div> -->
    <div class="arrow"></div>
    <div class="card">
      <h6>Pushed to Billing Desk</h6>
      <span
        v-if="
          PMC_itemDet.FFCreatedDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF Req CD. :{{ PMC_itemDet.FFCreatedDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.FFCUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF Req CB. :{{ PMC_itemDet.FFCUserName }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.FFUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF Req UD. :{{ PMC_itemDet.FFUpdateDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.FFUUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF Req UB. :{{ PMC_itemDet.FFUUserName }}<br />
      </span>
      <hr
        v-if="
          PMC_itemDet.FFUUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      />
      <span
        v-if="
          PMC_itemDet.CCCreatedDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC Req CD. :{{ PMC_itemDet.CCCreatedDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.CCCUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC Req CB. :{{ PMC_itemDet.CCCUserName }}<br
      /></span>
      <span
        v-if="
          PMC_itemDet.CCUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC Req UD. :{{ PMC_itemDet.CCUpdateDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.CCUUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC Req UB. :{{ PMC_itemDet.CCUUserName }}<br />
      </span>
      <hr
        v-if="
          PMC_itemDet.CCUUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      />
      <span
        v-if="
          PMC_itemDet.TPTCreatedDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT Req CD. :{{ PMC_itemDet.TPTCreatedDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.TPTCreatedDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT Req CB. :{{ PMC_itemDet.TPTCUserName }} <br
      /></span>
      <span
        v-if="
          PMC_itemDet.TPTUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT Req UD. :{{ PMC_itemDet.TPTUpdateDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.TPTUUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT Req UB. :{{ PMC_itemDet.TPTUUserName }}<br />
      </span>

      <span v-if="PMC_itemDet.MISCCreatedDate && PMC_itemDet.isMiscJob == '1'">
        MISC Req CD. :{{ PMC_itemDet.MISCCreatedDate }}<br />
      </span>
      <span v-if="PMC_itemDet.TBMISCCUserName && PMC_itemDet.isMiscJob == '1'">
        MISC Req CB. :{{ PMC_itemDet.TBMISCCUserName }}<br />
      </span>
      <span v-if="PMC_itemDet.MISCUpdateDate && PMC_itemDet.isMiscJob == '1'">
        MISC Req UD. :{{ PMC_itemDet.MISCUpdateDate }}<br />
      </span>
      <span v-if="PMC_itemDet.TBMISCUUserName && PMC_itemDet.isMiscJob == '1'">
        MISC Req UB. :{{ PMC_itemDet.TBMISCUUserName }} <br
      /></span>
    </div>
    <div class="delay">Delay<br/>
      <span v-if="PMC_itemDet.ff_tall_diff && PMC_itemDet.isMiscJob == '0'">FF:{{ PMC_itemDet.ff_tall_diff }}<br/></span>
      <span v-if="PMC_itemDet.cc_tall_diff && PMC_itemDet.isMiscJob == '0'">CC:{{ PMC_itemDet.cc_tall_diff }}<br/></span>
      <span v-if="PMC_itemDet.tpt_tall_diff && PMC_itemDet.isMiscJob == '0'">TPT:{{ PMC_itemDet.tpt_tall_diff }}<br/></span>
      <span v-if="PMC_itemDet.misc_tall_diff && PMC_itemDet.isMiscJob == '1'">MISC:{{ PMC_itemDet.misc_tall_diff }}</span>
    </div>
    <div class="card">
      <h6>Pushed to Tally</h6>
      <div v-if="PMC_itemDet.TallyBillingSeriesUsers">
        <span
          v-for="(item1, index) in PMC_itemDet.TallyBillingSeriesUsers.split(',')"
          :key="index"
          ><h6 v-for="(item2, index2) in item1.split(' - ')" :key="index2" >
            <b-badge >{{ item2 == "" ? "-------" : item2 }}</b-badge>
          </h6><hr/></span
        ><br/>
      </div>
      <span v-else>-----------</span>

      <!-- <span v-if="PMC_itemDet.TBInvNo && PMC_itemDet.isMiscJob == '0'"
        >TB Inv. :{{ PMC_itemDet.TBInvNo }}<br />
      </span>
      <span v-if="PMC_itemDet.TBCreatedDate && PMC_itemDet.isMiscJob == '0'"
        >TB CD. :{{ PMC_itemDet.TBCreatedDate }}<br />
      </span>
      <span v-if="PMC_itemDet.TBCUserName && PMC_itemDet.isMiscJob == '0'"
        >TB CB. :{{ PMC_itemDet.TBCUserName }}<br />
      </span> -->
      <!-- <span v-if="PMC_itemDet.TBUpdateDate && PMC_itemDet.isMiscJob == '0'"
        >TB UD. :{{ PMC_itemDet.TBUpdateDate }}<br />
      </span>
      <span v-if="PMC_itemDet.TBUUserName && PMC_itemDet.isMiscJob == '0'"
        >TB UB. :{{ PMC_itemDet.TBUUserName }}<br />
      </span> -->
      <!-- <hr v-if="PMC_itemDet.TBUUserName && PMC_itemDet.isMiscJob == '0'" />
      <span
        v-if="
          PMC_itemDet.TBFFInvNo &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF TB Inv. :{{ PMC_itemDet.TBFFInvNo }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.TBFFCreatedDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF TB CD. :{{ PMC_itemDet.TBFFCreatedDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.TBFFCUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF TB CB. :{{ PMC_itemDet.TBFFCUserName }}<br />
      </span> -->
      <!-- <span
        v-if="
          PMC_itemDet.TBFFUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF TB UD. :{{ PMC_itemDet.TBFFUpdateDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.TBFFUUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF TB UB. :{{ PMC_itemDet.TBFFUUserName }}<br />
      </span> -->
      <!-- <hr
        v-if="
          PMC_itemDet.TBFFUUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      />
      <span
        v-if="
          PMC_itemDet.TBCCInvNo &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC TB Inv. :{{ PMC_itemDet.TBCCInvNo }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.TBCCCreatedDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC TB CD. :{{ PMC_itemDet.TBCCCreatedDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.TBCCCUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC TB CB. :{{ PMC_itemDet.TBCCCUserName }}<br />
      </span> -->
      <!-- <span
        v-if="
          PMC_itemDet.TBCCUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC TB UD. :{{ PMC_itemDet.TBCCUpdateDate }} <br
      /></span>
      <span
        v-if="
          PMC_itemDet.TBCCUUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC TB UB. :{{ PMC_itemDet.TBCCUUserName }}<br />
      </span> -->
      <!-- <hr
        v-if="
          PMC_itemDet.TBCCUUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      />
      <span
        v-if="
          PMC_itemDet.TBTPTInvNo &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT TB Inv. :{{ PMC_itemDet.TBTPTInvNo }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.TBTPTCreatedDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT TB CD. :{{ PMC_itemDet.TBTPTCreatedDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.TBTPTCUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT TB CB. :{{ PMC_itemDet.TBTPTCUserName }}<br />
      </span> -->
      <!-- <span
        v-if="
          PMC_itemDet.TBTPTUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT TB UD. :{{ PMC_itemDet.TBTPTUpdateDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.TBTPTUUserName &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT TB UB. :{{ PMC_itemDet.TBTPTUUserName }}<br />
      </span> -->

      <!-- <span v-if="PMC_itemDet.TBInvNo && PMC_itemDet.isMiscJob == '1'">
        MISC TB Inv. :{{ PMC_itemDet.TBInvNo }}<br />
      </span>
      <span v-if="PMC_itemDet.TBCreatedDate && PMC_itemDet.isMiscJob == '1'">
        MISC TB CD. :{{ PMC_itemDet.TBCreatedDate }}<br />
      </span>
      <span v-if="PMC_itemDet.TBCUserName && PMC_itemDet.isMiscJob == '1'">
        MISC TB CB. :{{ PMC_itemDet.TBCUserName }}<br />
      </span> -->
      <!-- <span v-if="PMC_itemDet.TBUpdateDate && PMC_itemDet.isMiscJob == '1'">
        MISC TB UD. :{{ PMC_itemDet.TBUpdateDate }}<br />
      </span>
      <span v-if="PMC_itemDet.TBUUserName && PMC_itemDet.isMiscJob == '1'">
        MISC TB UB. :{{ PMC_itemDet.TBUUserName }}<br />
      </span> -->
    </div>
    <!-- 
    <div class="delay">Delay</div>
    <div class="card">
      <h6>Reverse Tally</h6>
      <span v-if="PMC_itemDet.RevInvNo">Rev. Inv. :{{ PMC_itemDet.RevInvNo }}<br /> </span>
      <span v-if="PMC_itemDet.RevInvDate"
        >Rev. Inv Date. :{{ PMC_itemDet.RevInvDate }}<br />
      </span>
      <span v-if="PMC_itemDet.RevInvAmt"
        >Rev. Inv Amt. :{{ PMC_itemDet.RevInvAmt }}<br />
      </span>
      <span v-if="PMC_itemDet.RevCreatedDate"
        >Rev. CD. :{{ PMC_itemDet.RevCreatedDate }}<br />
      </span>
      <span v-if="PMC_itemDet.RevUpdateDate"
        >Rev. UD. :{{ PMC_itemDet.RevUpdateDate }}<br />
      </span>
      <hr v-if="PMC_itemDet.RevUpdateDate" />
      <span
        v-if="
          PMC_itemDet.RevFFInvNo &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF Rev. Inv. :{{ PMC_itemDet.RevFFInvNo }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevFFInvDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
        >Rev. FF Inv Date. :{{ PMC_itemDet.RevFFInvDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevFFInvAmt &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF Rev. Inv Amt:{{ PMC_itemDet.RevFFInvAmt }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevFFCreatedDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF Rev. CD. :{{ PMC_itemDet.RevFFCreatedDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevFFUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      >
        FF Rev. UD. :{{ PMC_itemDet.RevFFUpdateDate }}<br />
      </span>
      <hr
        v-if="
          PMC_itemDet.RevFFUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('FF') >= 0
        "
      />
      <span
        v-if="
          PMC_itemDet.RevCCInvNo &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC Rev. Inv. :{{ PMC_itemDet.RevCCInvNo }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevCCInvDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
        >Rev. CC Inv Date. :{{ PMC_itemDet.RevCCInvDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevCCInvAmt &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC Rev. Inv Amt:{{ PMC_itemDet.RevCCInvAmt }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevCCCreatedDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC Rev. CD. :{{ PMC_itemDet.RevCCCreatedDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevCCUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      >
        CC Rev. UD. :{{ PMC_itemDet.RevCCUpdateDate }} <br
      /></span>
      <hr
        v-if="
          PMC_itemDet.RevCCUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('CC') >= 0
        "
      />
      <span
        v-if="
          PMC_itemDet.RevTPTInvNo &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT Rev. Inv. :{{ PMC_itemDet.RevTPTInvNo }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevTPTInvDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
        >Rev. TPT Inv Date. :{{ PMC_itemDet.RevTPTInvDate }}<br />
      </span>

      <span
        v-if="
          PMC_itemDet.RevTPTInvAmt &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT Rev. Inv Amt:{{ PMC_itemDet.RevTPTInvAmt }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevTPTCreatedDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT Rev. CD. :{{ PMC_itemDet.RevTPTCreatedDate }}<br />
      </span>
      <span
        v-if="
          PMC_itemDet.RevTPTUpdateDate &&
          PMC_itemDet.isMiscJob == '0' &&
          PMC_itemDet.JOBTYPE.indexOf('TPT') >= 0
        "
      >
        TPT Rev. UD. :{{ PMC_itemDet.RevTPTUpdateDate }}<br />
      </span>
    </div> -->
    <!-- <div class="arrow"></div> -->
    <!-- <div class="delay">Delay</div> -->
    <div class="arrow"></div>
    <div class="card status">
      <h6>Difference Reverse</h6>
       <div v-if="PMC_itemDet.TallyBillingSeriesWithLoginTimeAndDocDtlsNo"> 
        <span
          v-for="(item1, index) in PMC_itemDet.TallyBillingSeriesWithLoginTimeAndDocDtlsNo.split(',')"

          :key="index"
          ><h6 v-for="(item2, index2) in item1.split(' | ')" :key="index2"   >
            <b-badge 
            :variant="pattern.test(item2)?'danger':'primary'">{{ item2 == "" ? "-------" : item2 }}</b-badge>
          </h6></span
        ><br/>
      </div>
      <span v-else>-----------</span>
      <hr />
      <div v-if="PMC_itemDet.RevBillingSeries">
        <span
          v-for="(item1, index) in PMC_itemDet.RevBillingSeries.split(',')"
          :key="index"
          ><h6>
            <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }} </b-badge>
          </h6></span
        >
      </div>
      <br/>
      <b-button
        v-if="$sessionsStorage.get('departmentName').indexOf('Accounts')>=0 || this.$sessionsStorage.get('designation') == 'Admin'"
        @click="
          proceedBilling(
            PMC_itemDet.allModuleId,
            PMC_itemDet.newContainerFlow,
            PMC_itemDet.isConsolidation,
            PMC_itemDet.mainSalesSeries
          )
        "
        variant="primary"
        size="sm"
        >{{
          PMC_itemDet.finalBillingCompletedFlag == "1"
            ? "Show Billing"
            : "Proceed To Billing"
        }}</b-button>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { DateFormat, selectDateFormat,wordWrap } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";

export default {
  props: {
    PMC_item: {
      type: Object,
      default: {},
    },
  },
  beforeMount() {},
  mounted() {
    // Truncate HTML string when component is mounted
    this.truncatedHTML = this.truncateHTML(this.PMC_itemDet.assignmentCloseReason, this.maxLength);
  },

  data() {
    return {
      PMC_itemDet: this.PMC_item,
      docURL: URL_BASE_DOC,
      pattern:/Day Difference/i, ///\(Day Difference\)/,
      maxLength: 100, // Maximum length for truncation
      truncatedHTML: "", // Truncated HTML string
      expanded: false // Flag to track expansion state
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getJobHistoryList("Normal");
      },
      deep: true,
    },
  },
  methods: {
    proceedBilling(item, id, isConsolidation, mainSalesSeries) {
      this.$sessionsStorage.set("editSalesExId", item);
      if (isConsolidation == "1") {
        console.log("Consolidation");
        this.$router.push({
          path: "/consolidation/viewBillingDetails/" + item,
          query: { mainSalesSeries: mainSalesSeries },
        });
      } else {
        if (id == "1") {
          this.$router.push({
            path: "/allModuleForm/newTallyBillingMerge/" + item,
          });
        } else {
          this.$router.push({
            path: "/allModuleForm/newTallyBillingMerge/" + item,
          });
        }
      }
    },
    wordWrap,
    truncateHTML(htmlString, maxLength) {
      if (htmlString.length <= maxLength) {
        return htmlString;
      } else {
        // Truncate the HTML string and add ellipsis
        return htmlString.substring(0, maxLength) + "<br/>"+htmlString.substring(maxLength);
      }
    },
    expand() {
      // Toggle 'expanded' flag to show full HTML string
      this.expanded = true;
    }
  },
};
</script>
<style scoped>
.workflow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.card {
   /* prev  padding: 20px;  */
  padding: 10px;
  border: 2px solid black;
  /* Added by himanshu prev min-width: 150px; */
  min-width: 100px;
   overflow: auto;
    word-wrap: break-word;
    /* end */
   /* text-align: center;  */
}

.status {
  /* background-color: #f00; */
  /* color: #fff; color commented by*/
}
.arrow,
.delay {
  width: 42px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: column;
}

.arrow:after {
  content: "";
  position: absolute;
  left:  10%;
  top: 50%;
  transform: translate(0, -50%);
  border-style: solid;
  border-width: 30px 0 30px 30px;
  border-color: transparent transparent transparent #000;
}

.delay {
  background-color: #ff0;
}
</style>



// WEBPACK FOOTER //
// billingInvCard.vue?da7a2b3e